import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from './layouts/full/full-layout.component';

import { AuthGuard } from './shared/auth/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from 'app/register/register.component';
import { ProfileEditComponent } from 'app/users/profile-edit/profile-edit.component';
import { ForgotPasswordComponent } from './forgotpassword/forgotPassword.component';
import { MessageDetailComponent } from './messages/message-detail/message-detail.component';

const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '', component: FullLayoutComponent, data: { title: 'fullview' },
        children: [
            {
                path: 'dashboard',
                loadChildren: './dashboard/dashboard.module#DashboardModule'
            },
            {
                path: 'categories',
                loadChildren: './categories/categories.module#CategoriesModule'
            },
            {
                path: 'users-by-group',
                loadChildren: './users-by-group/users-by-group.module#UsersByGroupModule'
            },
            {
                path: 'messages',
                loadChildren: './messages/messages.module#InboxModule'
            },
            {
                path: 'classes',
                loadChildren: './classes/classes.module#ClassesModule'
            },
            {
                path: 'messages',
                loadChildren: './messages/messages.module#InboxModule'
            },
            {
                path: 'personal',
                loadChildren: './personal/personal.module#PersonalModule'
            },
            {
                path: 'forms',
                loadChildren: './forms/forms.module#FormsModule'
            },
            {
                path: 'support',
                loadChildren: './support/support.module#SupportModule'
            },
            {
                path: 'helps',
                loadChildren: './helps/helps.module#HelpModule'
            },
            {
                path: 'templates',
                loadChildren: './templates/templates.module#TemplatesModule'
            },
            {
                path: 'settings',
                loadChildren: './settings/settings.module#SettingsModule'
            },
            { path: 'profile', component: ProfileEditComponent },
        ], canActivate: [AuthGuard]
    },
    { path: 'login', component: LoginComponent },
    { path: 'forgotpassword', component: ForgotPasswordComponent },
    { path: 'register', component: RegisterComponent },
    {
        path: 'readmessage',
        children: [
            {
                path: ':uid/:mid',
                component: MessageDetailComponent,
            }, {
                path: ':uid/:mid/:rid',
                component: MessageDetailComponent,
            }
        ]
    }    
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes, {
        useHash: true,
        enableTracing: false, // debugging purposes only
    })],
    exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts